// Resource clusters — the top-level grouping for the /resources hub.
// `order` controls display order on the hub (lower = first).

/** @typedef {{key: string, name: string, order: number, description: string}} ResourceCluster */
/** @type {Record<string, ResourceCluster>} */
export const clusters = {
  data: {
    key: "data",
    name: "Research & data",
    order: 0,
    description: "Original data and methodology behind Listino's listing preps.",
  },
  seller: {
    key: "seller",
    name: "Selling your home",
    order: 1,
    description: "Why a listing isn't selling, and how to fix the price, photos, and description.",
  },
  agent: {
    key: "agent",
    name: "For real estate agents",
    order: 2,
    description: "Win the listing appointment, prep listings faster, and get more listings.",
  },
  compare: {
    key: "compare",
    name: "Compare & decide",
    order: 3,
    description: "Tools, options, and what optimizing a listing is actually worth.",
  },
};

export const clusterList = Object.values(clusters).sort((a, b) => a.order - b.order);

/** @param {string} key */
export const clusterName = (key) => clusters[key]?.name || "Resources";
